import React from 'react';

export default function SlideBanner({titleBanner = 'HỆ THỐNG BỆNH VIỆN', image = '/bw_image/medial-facility.png'}) {
    return (
        <section className="slide-banner">
            <div className="slide-banner__bg-wrapper">
                <img className="slide-banner__bg" src={image} alt={titleBanner} />
                <div className="slide-banner__content">
                    <h1 className="slide-banner__title">{titleBanner}</h1>
                </div>
            </div>
        </section>
    );
}
